module.exports = "https://coursera_assets.s3.amazonaws.com/images/74c8747e8210831049cf88dd4eefe26c.png";